var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div id=\"recaptchaV3\" ng-if=\"asmReCaptcha.showRecaptchaV3\">\n<div class=\"block-ui-message-container\" aria-live=\"assertive\" aria-atomic=\"true\">\n<div class=\"block-ui-message md-hue-2\" ng-class=\"$_blockUiMessageClass\">\n<div>Validating...</div>\n<md-progress-circular md-theme=\"success\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"100px\"></md-progress-circular>\n</div>\n</div>\n</div>\n<div vc-recaptcha theme=\"light\" key=\"asmReCaptcha.recaptchaSettings.reCaptcha2PublicKey\" ng-if=\"asmReCaptcha.recaptchaSettings && asmReCaptcha.recaptchaSettings.isEnabled && asmReCaptcha.showRecaptchaV2\" on-create=\"asmReCaptcha.setRecaptchaV2WidgetId(widgetId)\" on-success=\"asmReCaptcha.onRecaptchaV2Succeeded(response)\" on-expire=\"asmReCaptcha.onReCaptchaV2Failed()\" on-error=\"asmReCaptcha.onReCaptchaV2Failed()\">\n</div>\n</div>";
var id1="app/user-controls/recaptcha.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/user-controls/recaptcha.html
// module id = 595
// module chunks = 0